export const DATE_NOW = '2024-01-01';
